import React, { useRef, useState } from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);

  const startMusic = () => {
    if (audioRef.current) {
      audioRef.current.play().then(() => {
        setPlaying(true);
        setShowPrompt(false);
      }).catch(() => {});
    }
  };

  const toggleMusic = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      audioRef.current.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <div className="layout-wrapper">
      <audio ref={audioRef} src="/jana-gana-mana.ogg" loop preload="auto" />

      {/* First-visit prompt */}
      {showPrompt && (
        <div style={{
          position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
          zIndex: 9999, background: '#fff', borderRadius: '14px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)', padding: '16px 28px',
          display: 'flex', alignItems: 'center', gap: '14px',
          border: '2px solid #ff9933'
        }}>
          <span style={{ fontSize: '24px' }}>🇮🇳</span>
          <span style={{ fontWeight: 600, color: '#333', fontSize: '14px' }}>
            Play Jana Gana Mana (Instrumental)?
          </span>
          <button onClick={startMusic} style={{
            background: '#138808', color: '#fff', border: 'none',
            borderRadius: '8px', padding: '7px 16px', fontWeight: 700,
            fontSize: '13px', cursor: 'pointer'
          }}>
            ▶ Play
          </button>
          <button onClick={() => setShowPrompt(false)} style={{
            background: '#eee', color: '#555', border: 'none',
            borderRadius: '8px', padding: '7px 12px', fontSize: '13px', cursor: 'pointer'
          }}>
            ✕
          </button>
        </div>
      )}

      {/* Floating mute/unmute button */}
      {!showPrompt && (
        <button onClick={toggleMusic} title={playing ? 'Pause music' : 'Play Jana Gana Mana'} style={{
          position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999,
          width: '48px', height: '48px', borderRadius: '50%', border: 'none',
          background: playing ? '#138808' : '#aaa',
          color: '#fff', fontSize: '20px', cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background 0.2s'
        }}>
          {playing ? '🎵' : '🔇'}
        </button>
      )}

      <Header />
      <main className="main-content">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
